// Include flickity
import 'flickity/dist/flickity.pkgd.min.js';
import 'flickity-sync/flickity-sync.js';

// Set global arrowShape
const arrowShape = 'M82.6,46H1.3v8.7h81.1L63.9,73l6.2,6.1l29.2-29l-29.2-29l-6.2,6.1L82.6,46z';

// Init sliders
$(window).on('ready load', function() {

  // Banner slider @TODO: Delete if isn't used in theme
  if($('.banner__slider').length && $('.banner__item').length > 1) {
    $('.banner__slider').flickity({
      contain: true,
      wrapAround: true,
      cellAlign: 'left',
      arrowShape: arrowShape,
    });
    $('.banner__slider').flickity('resize');
  }

  // News slider
  $('.news-slider').each(function(i, e) {
    if($(e).length && (
      ($(window).width() < 768 && $(e).find('.news-slider__item').length > 1) ||
      ($(window).width() > 767 && $(window).width() < 1025 && $(e).find('.news-slider__item').length > 2) ||
      ($(window).width() > 1024 && $(e).find('.news-slider__item').length > 3)
    )) {
      $(e).flickity({
        arrowShape: arrowShape,
        cellAlign: 'left',
        contain: true,
        groupCells: true,
      });
      $(e).flickity('resize');
    } else if($(e).hasClass('flickity-enabled')) {
      $(e).flickity('destroy');
    }
  });

  // USP slider
  if ($('.js-usp-slider').length && $('.js-usp-slider-single').length > 1) {
    var uspslider = $('.js-usp-slider').flickity({
      contain: true,
      wrapAround: true,
      cellAlign: 'left',
      watchCSS: true,
      autoPlay: 3000,
      prevNextButtons: false,
      pageDots: false,
      initialIndex: Math.floor(Math.random() * $('.js-usp-slider-single').length),
    });
    uspslider.flickity('resize');
    $(window).on('ready load', function () {
      uspslider.flickity('resize');
    });
  }

  // Plan slider
  if ($('.js-plan-slider').length && $('.js-plan-slider-single').length > 1) {
    var planslider = $('.js-plan-slider').flickity({
      contain: true,
      wrapAround: true,
      cellAlign: 'center',
      watchCSS: true,
      autoPlay: 5000,
      prevNextButtons: false,
      pageDots: false,
      initialIndex: Math.floor(Math.random() * $('.js-plan-slider-single').length),
    });
    planslider.flickity('resize');
    $(window).on('ready load', function () {
      planslider.flickity('resize');
    });
  }

  // Image slider
  $('.js-img-slider').each(function(i, e) {
    if($(e).length && $(e).find('.js-img-slider__item').length > 1) {
      $(e).flickity({
        wrapAround: true,
        arrowShape: arrowShape,
      });

      $(e).flickity('resize');
    }
  });

  // Image slider
  $('.testimonial__text-slider').each(function(i, e) {
    if($(e).length && $(e).find('.testimonial__text-item').length > 1) {
      $(e).flickity({
        sync: '.testimonial__info-slider',
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
      });

      $('.testimonial__info-slider').flickity({
        contain: true,
        arrowShape: arrowShape,
      });

      $(e).flickity('resize');
      $('.testimonial__info-slider').flickity('resize');
    }
  });

  // Team slider
  $('.team-slider').each(function(i, e) {
    if($(e).length && $(e).find('.card-team').length > 1) {
      $(e).flickity({
        watchCSS: true,
        wrapAround: true,
        arrowShape: arrowShape,
      });

      $(e).flickity('resize');
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/global/flickity.js